<!--
 * @Author: your name
 * @Date: 2020-11-12 17:40:42
 * @LastEditTime: 2021-01-27 15:36:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/LeftPopupDialog/index.vue
-->
<style scoped lang="sass">

.app_container
  position: relative
  display: flex
  flex-direction: column
  justify-content: space-between
  height: 100%
  padding: 63PX 8PX 25PX 14PX

.close_icon
  position: absolute
  top: 20PX
  left: 20PX
  padding: 5PX
  color: var(--menu-primary-background-colour) !important

::v-deep
  .van-button--primary
    border: none
    border-radius: 5PX !important

.loading_popup
  position: absolute !important
  left: 0

</style>

<style lang="sass" scoped>
.popup_container
  height: 100%
  width: 80%
</style>

<template lang="pug">
van-popup.popup_container(
  :value="show"
  :close-on-click-overlay="false"
  :position="position"
  @click-overlay="handleClickMask"
)
  .app_container
    slot(name="popup-dialog")
    icon(size="26").close_icon(@click="closeDialog") close
    py-loading.loading_popup(
      :showLoading="showPopupLoading"
      :size="popupLoadingSize"
    )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'

@Component({
  model: {
    prop: 'show',
    event: 'changeShow'
  },
  props: {
    show: {
      type: Boolean
    },

    dialogHeight: {
      type: [String, Number],
      default: 50
    },

    color: {
      type: String,
      default: '#000'
    },

    popupLoadingSize: {
      type: String,
      default: '50'
    },

    showPopupLoading: {
      type: Boolean,
      default: false
    },

    position: {
      type: String,
      default: 'left'
    }
  }
})

class LeftPopupDialog extends Vue {
  closeDialog() {
    this.$emit('changeShow', false)
  }

  handleClickMask() {
    this.$emit('changeShow', false)
  }
}

export default LeftPopupDialog
</script>
